import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------

function createGradient(color1, color2) {
  return `linear-gradient(to right, ${color1}, ${color2})`;
  //return `-webkit-linear-gradient(${color1}, ${color2})`;
  //return `-webkit-linear-gradient(#eee, #333)`;
}

// SETUP COLORS
// Leaving Grey alone for now... :)
const GREY = {
  0: "#FFFFFF",
  50: "#f8f6ff",
  100: "#efecfa",
  200: "#e2e0ed",
  300: "#aba9b5",
  400: "#aba9b5",
  500: "#8a8894",
  600: "#63616c",
  700: "#504e59",
  800: "#32303a",
  900: "#12101a",
  500_8: alpha("#8a8894", 0.08),
  500_12: alpha("#8a8894", 0.12),
  500_16: alpha("#8a8894", 0.16),
  500_24: alpha("#8a8894", 0.24),
  500_32: alpha("#8a8894", 0.32),
  500_48: alpha("#8a8894", 0.48),
  500_56: alpha("#8a8894", 0.56),
  500_80: alpha("#8a8894", 0.8),
};

const PRIMARY = {
  main: "#6A2DFA",
};

const SECONDARY = {
  main: "#70C6FD",
};

const INFO = {
  lighter: "#D0F2FF",
  light: "#74CAFF",
  main: "#1890FF",
  dark: "#0C53B7",
  darker: "#04297A",
  contrastText: "#fff",
};

const SUCCESS = {
  main: "#52CC8B",
};

const WARNING = {
  main: "#fdb01b",
};

const ERROR = {
  main: "#FF5959",
};

const GRADIENTS = {
  primary: createGradient(PRIMARY.main, SECONDARY.main),
  // info: createGradient(INFO.light, INFO.main),
  // success: createGradient(SUCCESS.light, SUCCESS.main),
  // warning: createGradient(WARNING.light, WARNING.main),
  // error: createGradient(ERROR.light, ERROR.main),
};

const CHART_COLORS = {
  violet: ["#826AF9", "#9E86FF", "#D0AEFF", "#F7D2FF"],
  blue: ["#2D99FF", "#83CFFF", "#A5F3FF", "#CCFAFF"],
  green: ["#2CD9C5", "#60F1C8", "#A4F7CC", "#C0F2DC"],
  yellow: ["#FFE700", "#FFEF5A", "#FFF7AE", "#FFF3D6"],
  red: ["#FF6C40", "#FF8F6D", "#FFBD98", "#FFF2D4"],
};

const palette = {
  common: { black: "#000", white: "#fff" },
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  info: { ...INFO },
  success: { ...SUCCESS },
  warning: { ...WARNING },
  error: { ...ERROR },
  grey: GREY,
  gradients: GRADIENTS,
  chart: CHART_COLORS,
  divider: GREY[500_24],
  text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
  background: { paper: "#fff", default: "#FCFCFC", disabled: "#F4F3FE" },
  action: {
    active: GREY[600],
    hover: GREY[500_8],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: "#D9D6E7",
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
